import Input from "../../../Core/Fields/Floating/Input"

const Tab1 = ({vendor,po}) => {

  return (
    <div
     className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px", height: '67vh', overflowY: 'scroll',flexWrap:'nowrap' }}
    >
      <div className="col-12 mb-2">
        <Input id="termsandconditions" label="Put Away No." readOnly value={po?.po} style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-2">

        <Input id="termsandconditions" label="BOM No." readOnly value={po?.bom_no} style={{ height: '30px' }} />

      </div>

      <div className="col-12 mb-2">

        <Input id="termsandconditions" label="Work Order" readOnly value={po?.work_order} style={{ height: '30px' }} />

      </div>
      <div className="col-12 mb-2">
  
        <Input id="termsandconditions" label="Transaction Type" readOnly value={po?.stock_entry_type} style={{ height: '30px' }} />

        
      </div>


      
     
     </div>
  )
}

export default Tab1